import React, { useRef } from "react";
import { connect } from "react-redux";
import * as actions from "../../Store/Actions/index";
import SystemCosts from "../../Components/Forms/SystemCosts";
import TotalCosts from "../../Components/Forms/TotalCosts";
import RetrainingCosts from "../../Components/Forms/RetrainingCosts";
import ProductivityLoss from "../../Components/Forms/ProductivityLoss";
import Introduction from "../../Components/Introduction/Introduction";
import Benefits from "../../Components/Forms/Benefits";
import Summary from "../../Components/Forms/Summary"
import { Carousel } from "antd";

const RenderCarousel = (props) => {
    const carouselRef = useRef();

    //alert("Rendering carousel")
    if (carouselRef.current) {
        carouselRef.current.goTo(props.currentStepStore)
    }
    
    const handleChange = (newStep) => {
        props.setCurrentStepStore(newStep)
    }

    return (
        <Carousel ref={carouselRef} dots={false} afterChange={handleChange}>
        <div className="carousel-content">
          <Introduction />
        </div>

        <div className="carousel-content">
          <RetrainingCosts />
        </div>

        <div className="carousel-content">
          <ProductivityLoss />
        </div>

        <div className="carousel-content">
          <SystemCosts />
        </div>

        <div className="carousel-content">
          <Benefits />
        </div>

        <div className="carousel-content">
          <TotalCosts />
        </div>

        <div className="carousel-content">
          <Summary />
        </div>
      </Carousel>
    );
}

const mapStateToProps = (state) => {
    return {
      currentStepStore: state.status.currentStep
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      setCurrentStepStore: (currentStepStore) => dispatch(actions.setCurrentStep(currentStepStore))
    };
  };

export default connect(mapStateToProps, mapDispatchToProps)(RenderCarousel);
